import NewRegistration from "./types/NewRegistration.vue"
import ProfileReview from "./types/ProfileReview.vue"
import Rejected from "./types/Rejected.vue"
import ProfileCompletionPending from "./types/ProfileCompletionPending.vue"
import PasswordCreationPending from "./types/PasswordCreationPending.vue"
import Approved from "./types/Approved.vue"

const NEW_REGISTRATION = "new-registration"

const PROFILE_REVIEW = "profile-review"

const REJECTED = "rejected"

const PROFILE_COMPLETION_PENDING = "profile-completion-pending"

const PASSWORD_CREATION_PENDING = "password-creation-pending"

const APPROVED = "approved"

export default [
  {
    id: NEW_REGISTRATION,
    component: NewRegistration,
  },
  {
    id: PROFILE_REVIEW,
    component: ProfileReview,
  },
  {
    id: REJECTED,
    component: Rejected,
  },
  {
    id: PROFILE_COMPLETION_PENDING,
    component: ProfileCompletionPending,
  },
  {
    id: PASSWORD_CREATION_PENDING,
    component: PasswordCreationPending,
  },
  {
    id: APPROVED,
    component: Approved,
  },
]

export {
  NEW_REGISTRATION,
  PROFILE_REVIEW,
  REJECTED,
  PROFILE_COMPLETION_PENDING,
  PASSWORD_CREATION_PENDING,
  APPROVED,
}
